import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui";
import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { cn } from "@/lib/utils/cn";
import { useFormContext, type UseFormRegisterReturn } from "react-hook-form";

interface CheckboxFormFieldProps {
  register: UseFormRegisterReturn;
  label?: React.ReactNode | string;
  disabled?: boolean;
  disabledMessage?: string;
  className?: string;
}

export const CheckboxFormField = ({
  register,
  label = "checkbox",
  disabled,
  disabledMessage,
  className,
}: CheckboxFormFieldProps) => {
  const form = useFormContext();
  return (
    <FormField
      control={form.control}
      {...register}
      //@ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem
          className={cn(
            "mt-6 flex h-[38px] flex-row items-center justify-between",
            className,
          )}
        >
          <div className="space-y-0.5">
            <FormLabel>{label}</FormLabel>
          </div>
          <FormControl>
            <TooltipWrapper message={disabled ? disabledMessage : ""}>
              <Checkbox
                disabled={disabled}
                checked={field.value}
                onCheckedChange={(value) => {
                  if (value !== field.value) {
                    field.onChange(value);
                  }
                }}
              />
            </TooltipWrapper>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
